import React from 'react';

export const useDialogState = <T>(onChange?: (value: T) => void) => {
  const [isDialogOpen, setDialogOpen] = React.useState(false);

  const openDialog = React.useCallback(() => {
    setDialogOpen(true);
  }, [setDialogOpen]);

  const closeDialog = React.useCallback(
    (newValue?: T) => {
      setDialogOpen(false);
      if (newValue !== undefined && onChange) {
        onChange(newValue);
      }
    },
    [setDialogOpen, onChange]
  );

  return [isDialogOpen, openDialog, closeDialog] as const;
};
